import React, { useEffect, useState } from "react";
// import TradingViewTerminal from "../partials/TradingViewTerminal";
import AccountTabs from "./AccountTabs";
import PositionTable from "./PositionTable";
import TradingViewTerminal from "../TradingViewTerminal";
import { useTranslation } from "react-i18next";
import OrdersTable from "./OrdersTable";
import AccountSummary from "./AccountSummary";
import NotificationLogs from "./NotificationLogs";
import { useDispatch, useSelector } from "react-redux";
import {
  useGetAllOrdersQuery,
  useGetWorkingOrdersQuery,
  useGetCancelledOrdersQuery,
  useGetClosedPositionsQuery,
  useCancelOrderMutation,
  useCreateOrderMarketMutation,
} from "../../../redux/exchangeUniApi";
import {
  setCancelOrders,
  setClosedOrders,
  setOrders,
  setPendingOrders,
} from "../../../redux/ordersSlice";
import toast from "react-hot-toast";
import { formatDecimal } from "../../../util/decimalFormatter";

const TradingChartBox = ({
  setIsOrderBoxShow,
  getExistingOrder,
  manageScreenSize,
  setScreenSize,
  theme,
  stepSize,
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("positions");
  const [orderSide, setOrderSide] = useState("all");
  const [submitLock, setSubmitLock] = useState(false);
  const account = useSelector((state) => state.account);
  const [createMarketOrder] = useCreateOrderMarketMutation();
  const [quantity, setQuantity] = useState("0.01");
  const [hasError, setHasError] = useState(false);
  const [cancelOrder, { isLoading }] = useCancelOrderMutation();
  const dispatch = useDispatch();
  const userId = useSelector((state) => state?.user?.userData?.id);
  const positions = useSelector((state) => state.positions.data);
  const { data: allOrders } = useGetAllOrdersQuery(userId);
  const { data: workingOrders } = useGetWorkingOrdersQuery(userId);
  const { data: cancelledOrders } = useGetCancelledOrdersQuery(userId);
  const { data: closedPositions } = useGetClosedPositionsQuery(userId);
  const selectedSymbol = useSelector((state) => state.watchlist.selectedSymbol);
  const allMerge = useSelector((state) => state.orders);
  const livePrice = useSelector(
    (state) => state.market.prices[selectedSymbol?.toUpperCase()]
  );
  const selectedSegment = useSelector(
    (state) => state.watchlist.selectedSegment
  );
  const userData = useSelector((state) => state.user.userData);
  const watchlist = useSelector((state) => state.watchlist.items);
  const selectedSymbolObj = watchlist.find(
    (item) => item.symbol === selectedSymbol
  );
  const instrumentId = selectedSymbolObj?.instrument_id;

  useEffect(() => {
    if (allOrders && workingOrders && closedPositions && cancelledOrders) {
      dispatch(setOrders(allOrders));
      dispatch(setPendingOrders(workingOrders));
      dispatch(setClosedOrders(closedPositions));
      dispatch(setCancelOrders(cancelledOrders));
    }
  }, [allOrders, workingOrders, closedPositions, cancelledOrders, dispatch]);

  useEffect(() => {
    setSubmitLock(false);
    setHasError("");
    setQuantity(stepSize || "0.01");
  }, [selectedSegment, selectedSymbol, stepSize]);

  const handleSubmit = async (side) => {
    const error = handleChange(quantity.toString());
    if (error) {
      toast.error(error);
      setHasError(error);
    }
    console.log(error, "error");
    if (error || submitLock) return;
    console.log("hiiii");
    setSubmitLock(true);
    // return;

    const payload = {
      user_id: userData?.id,
      broker_id: userData?.refred_by_id,
      instrument_id: instrumentId,
      stop_loss: null,
      take_profit: null,
      side,
      order_type: "market",
      quantity: parseFloat(quantity),
      leverage: 1,
    };

    const res = await createMarketOrder(payload);

    if (res?.data?.success) {
      setSubmitLock(false);
      setHasError("");
      setQuantity("0.01");
    } else {
      toast.error(res?.error?.data?.message || "Failed to place order", {
        position: "top-right",
      });
    }
  };

  let ordersToRender = [];

  switch (orderSide) {
    case "all":
      ordersToRender = allMerge.allOrders ?? [];
      break;
    case "working":
      ordersToRender = allMerge.pendingOrders ?? [];
      break;
    case "cancelled":
      ordersToRender = allMerge.cancelOrders ?? [];
      break;
    case "filled":
      ordersToRender = allMerge.closedOrders ?? []; // ← this will show filled positions
      break;
    default:
      ordersToRender = [];
  }

  const handleChange = (val) => {
    console.log(val, "val");
    if (val <= 0) {
      return "Zero or Negative values not allowed.";
    }

    const str = val.toString().trim();
    if (/[^0-9.]/.test(str)) {
      return "Only numeric values allowed.";
    }

    if (/[^0-9.]/.test(val)) {
      return "Enter a valid amount.";
    }

    // Prevent multiple dots
    if ((val.match(/\./g) || []).length > 1) {
      return "Only one decimal point allowed.";
    }

    // Prevent leading 0s like 00.12 unless it's 0.
    if (/^0\d+/.test(val)) {
      return "Invalid leading zero format.";
    }

    if (!val) {
      return "This field is required.";
    }

    const [intPart] = val.split(".");
    if (intPart.length > 8) {
      return "Max 8 digits allowed before decimal.";
    }

    const numeric = parseFloat(val);
    if (!isNaN(numeric) && numeric < stepSize) {
      setHasError(
        `Specified value is less than the instrument minimum of ${stepSize}.`
      );
    }

    if (selectedSegment === "equity" && !/^\d*$/.test(val)) {
      return "Equity quantity must be a whole number.";
    }

    if (selectedSegment === "forex" && !/^\d*\.?\d{0,2}$/.test(val)) {
      return "Forex quantity must be max 2 decimal places.";
    }

    if (selectedSegment === "crypto") {
      const allowedDecimals = stepSize.toString().split(".")[1]?.length || 0;
      const regex = new RegExp(`^\\d*\\.?\\d{0,${allowedDecimals}}$`);
      if (!regex.test(val)) {
        return `Crypto allows max ${allowedDecimals} decimals.`;
      }
    }

    return "";
  };

  const handleCancelled = async (orderId) => {
    const payload = {
      user_id: userId,
      order_id: orderId,
    };
    if (submitLock) return;
    setSubmitLock(true);

    const res = await cancelOrder(payload);

    if (res?.data?.success) {
      // toast.success("Order Cancelled");
      setSubmitLock(false);
    } else {
      // toast.error(res?.error?.data?.message || "Failed to place order");
    }
  };

  return (
    <>
      <div className="ne_box bg2 border_box position-relative">
        <TradingViewTerminal
          theme={theme}
          manageScreenSize={manageScreenSize}
        />
        <ul class="chart_buy_sell  d-flex  position-absolute align-items-center">
          <li
            class={`drag-cancel my_color_sell ${
              submitLock ? "btn-disabled" : ""
            }`}
            onClick={() => handleSubmit("SELL")}
          >
            {formatDecimal(livePrice?.bid)}
          </li>

          <input
            type="text"
            inputMode="decimal"
            className="bg2"
            // pattern="[0-9]*"
            // onBlur={handleBlur}
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            placeholder="Enter Quantity"
            style={{
              border: hasError ? "2px solid #e40058" : "",
              borderRadius: "4px",
            }}
          />

          <li
            class={`drag-cancel my_color_buy  ${
              submitLock ? "btn-disabled" : ""
            }`}
            onClick={() => handleSubmit("BUY")}
          >
            {formatDecimal(livePrice?.ask)}
          </li>
        </ul>
      </div>

      <div
        className={`ne_box border_box p-2 bg2 ${
          manageScreenSize === "tv_chart_container2-lower"
            ? "trading_table_section-lower "
            : manageScreenSize === "tv_chart_container2-zero"
            ? "trading_table_section-f"
            : "trading_table_section"
        }`}
      >
        <div className="d-flex align-items-center">
          <h6 className="mb-2 mr-3">Account Manager</h6>
          <span
            onClick={() => setIsOrderBoxShow((prev) => !prev)}
            className="mr-auto icon_h_b_btn"
          >
            Trade
          </span>
          <span
            className="icon_hover mr-2"
            onClick={() => {
              if (manageScreenSize === "tv_chart_container2-lower") {
                setScreenSize("tv_chart_container2");
              } else if (manageScreenSize === "tv_chart_container2-zero") {
                setScreenSize("tv_chart_container2-lower");
              } else if (manageScreenSize === "tv_chart_container2") {
                setScreenSize("tv_chart_container2-lower");
              }
            }}
          >
            {manageScreenSize === "tv_chart_container2-lower" ? (
              <i class="bi bi-chevron-compact-up"></i>
            ) : (
              <i className="bi bi-dash-lg" style={{ fontSize: "20px" }} />
            )}
          </span>
          <span
            className="icon_hover"
            onClick={() => {
              if (manageScreenSize === "tv_chart_container2-lower") {
                setScreenSize("tv_chart_container2-zero");
              } else if (manageScreenSize === "tv_chart_container2-zero") {
                setScreenSize("tv_chart_container2");
              } else if (manageScreenSize === "tv_chart_container2") {
                setScreenSize("tv_chart_container2-zero");
              }
            }}
          >
            {manageScreenSize === "tv_chart_container2-zero" ? (
              <i className="bi bi-fullscreen-exit" />
            ) : (
              <i class="bi bi-fullscreen"></i>
            )}
          </span>
        </div>
        {/* <AccountStatsBar openPnl={parseFloat(openPnl)} /> */}
        <AccountTabs
          openPnl={account?.openPnl}
          totalPL={account?.totalPnl}
          activeTab={activeTab}
          onTabChange={setActiveTab}
          positionsCount={positions.length}
        />

        {/* <PositionTable /> */}

        <div key={"orderdetails"}>
          <div className="fs13 h_100">
            <div className="ne_box h_100 p-d3 br10  bg2">
              {activeTab === "positions" && (
                <PositionTable
                  positions={positions}
                  onEdit={getExistingOrder}
                  manageScreenSize={manageScreenSize}
                />
              )}
              {activeTab === "orders" && (
                <div className="buy-order-outer tab-content h_100 ">
                  {(orderSide === "all" ||
                    orderSide === "working" ||
                    orderSide === "filled" ||
                    orderSide === "cancelled") && (
                    <div className="position_tab_in d-flex mb-2 mb-md-0">
                      <a
                        href="#!"
                        onClick={() => setOrderSide("all")}
                        className={orderSide === "all" ? "active" : ""}
                      >
                        {t("All")} {allMerge?.allOrders?.length}
                      </a>
                      <a
                        href="#!"
                        onClick={() => setOrderSide("working")}
                        className={orderSide === "working" ? "active" : ""}
                      >
                        {t("Working")} {allMerge?.pendingOrders?.length}
                      </a>
                      <a
                        href="#!"
                        onClick={() => setOrderSide("filled")}
                        className={orderSide === "filled" ? "active" : ""}
                      >
                        {t("Filled")} {allMerge?.closedOrders?.length}
                      </a>
                      <a
                        href="#!"
                        onClick={() => setOrderSide("cancelled")}
                        className={orderSide === "cancelled" ? "active" : ""}
                      >
                        {t("Cancelled")} {allMerge?.cancelOrders?.length}
                      </a>
                    </div>
                  )}
                  <OrdersTable
                    t={t}
                    manageScreenSize={manageScreenSize}
                    orderType={orderSide}
                    orders={ordersToRender}
                    onCancel={handleCancelled}
                    onEdit={() => {}}
                    submitLock={submitLock}
                  />
                </div>
              )}
              {activeTab === "summary" && <AccountSummary />}
              {activeTab === "logs" && (
                <NotificationLogs manageScreenSize={manageScreenSize} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TradingChartBox;
